"use strict";exports.mean=function(e){return e.length<1?NaN:e.reduce((function(e,n){return e+n}),0)/e.length};
//# sourceMappingURL=mean.cjs.map
